<template>
  <div class="privacy-policy">
    <div class="container">
      <h1>Privacy Policy</h1>

      <div class="content">
        <p class="updated"><strong>Last Updated:</strong> {{ lastUpdated }}</p>

        <h2>Overview</h2>
        <p>
          This Privacy Policy explains how we collect, use, disclose and protect your personal information when you use our website or services.
          By using the Services you accept the terms of this policy.
        </p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li v-for="item in infoCollect" :key="item">{{ item }}</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li v-for="use in uses" :key="use">{{ use }}</li>
        </ul>

        <h2>3. How We Share Your Information</h2>
        <ul>
          <li v-for="share in shares" :key="share">{{ share }}</li>
        </ul>

        <h2>4. International Transfers</h2>
        <p>
          Your information may be transferred to, and processed in, countries other than the one in which you live.
          We take reasonable steps to ensure it is protected in accordance with this policy.
        </p>

        <h2>5. Data Retention</h2>
        <p>
          We retain personal data only as long as necessary to provide the Services, comply with legal obligations,
          resolve disputes, and enforce our agreements.
        </p>

        <h2>6. Your Rights</h2>
        <ul>
          <li v-for="right in rights" :key="right">{{ right }}</li>
        </ul>

        <h2>7. Data Security</h2>
        <p>
          We implement reasonable technical and organizational measures to protect personal data,
          but no internet transmission is completely secure.
        </p>

        <h2>8. Children’s Privacy</h2>
        <p>
          The Services are not intended for children under 16.
          We do not knowingly collect information from children; if discovered, we will promptly delete it.
        </p>

        <h2>9. Third-Party Links</h2>
        <p>
          Our site may link to third-party websites. We are not responsible for their privacy practices.
        </p>

        <h2>10. Changes to this Policy</h2>
        <p>
          We may update this policy from time to time. Updates will be posted here with the new "Last Updated" date.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      lastUpdated: '2025-11-18',
      infoCollect: [
        'Personal information you provide (name, email, phone, company, account credentials)',
        'Automatically collected data (IP address, device, browser, pages viewed, cookies)',
        'Information from forms, surveys, and support interactions'
      ],
      uses: [
        'To provide and maintain the Services',
        'To respond to inquiries and provide support',
        'To personalise content and improve user experience',
        'To detect and prevent fraud or abuse'
      ],
      shares: [
        'Third-party service providers (hosting, analytics, email delivery) who process data on our behalf',
        'When required by law or to protect rights and safety',
        'In connection with a corporate transaction such as a merger or sale'
      ],
      rights: [
        'Access your personal data',
        'Correct inaccurate information',
        'Request deletion of your data',
        'Object to or restrict processing',
        'Request data portability'
      ]
    }
  }
}
</script>

<style scoped>
/* 整体布局 */
.privacy-policy {
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  min-height: 60vh;
}

/* 自适应容器 */
.container {
  width: 100%;
  max-width: 900px;
}

/* 标题样式 */
h1 {
  text-align: center;
  margin-bottom: 32px;
  color: #2444CB;
  font-size: 32px;
  font-weight: 700;
}

/* 内容区 */
.content {
  line-height: 1.7;
  font-size: 16px;
  color: #333;
}

/* 二级标题 */
h2 {
  margin-top: 28px;
  margin-bottom: 12px;
  font-size: 20px;
  font-weight: 600;
  color: #222;
}

/* 列表优化 */
ul {
  padding-left: 20px;
  margin: 8px 0 16px;
}

li {
  margin-bottom: 6px;
}

/* 更新时间 */
.updated {
  margin-bottom: 20px;
  color: #666;
}

/* ---------- 响应式适配 ---------- */

/* 平板（竖屏） */
@media (max-width: 992px) {
  h1 {
    font-size: 28px;
  }

  .content {
    font-size: 15px;
  }
}

/* 中小屏手机 */
@media (max-width: 768px) {
  .privacy-policy {
    padding: 30px 16px;
  }

  h1 {
    font-size: 26px;
  }

  h2 {
    font-size: 18px;
  }
}

/* 小手机（iPhone SE 等） */
@media (max-width: 480px) {
  h1 {
    font-size: 22px;
  }

  .content {
    font-size: 14px;
  }

  h2 {
    font-size: 17px;
  }
}
</style>
